import React, { FC, memo } from "react";

import { Form } from "./Form";
import { FormContainer } from "../sign-in/FormContainer";

const SignUpComponent: FC = () => {
  return (
    <FormContainer>
      <Form />
    </FormContainer>
  );
};

export const SignUp = memo(SignUpComponent);
